import { UseFormReturn } from "react-hook-form";
import { Box, Typography } from "@mui/material";

import { FormTitle, FieldLabel } from "../components";
import DropdownInput from "@/components/RHFcomponents/DropdownInput";
import RangeField from "@/components/RHFcomponents/RangeField";
import { industryOptions } from "../utils/selectOptions";

interface IProp {
  methods: UseFormReturn<IFleetInquiryForm, unknown, undefined>;
}

const FormSecondStep: React.FC<IProp> = ({ methods: { control, watch } }) => {
  const industryIsEmpty = !watch().businessType;

  return (
    <>
      <FormTitle
        title="Your fleet details"
        subtitle="Understanding the basics of your fleet, including size and industry, helps us tailor our solutions to meet your specific needs effectively."
        withHeader
      />
      <Box display="flex" gap={4} flexDirection="column">
        <Box>
          <FieldLabel label="Select industry" mb={{ xs: 1, md: 2 }} />
          <DropdownInput
            name="businessType"
            control={control}
            placeholder="Select industry"
            options={industryOptions}
          />
          {industryIsEmpty && (
            <Typography variant="body1" color="text.secondary" mt={1}>
              e.g., Logistics, Construction, Services
            </Typography>
          )}
        </Box>

        <Box>
          <FieldLabel label="Number of vehicles" mb={{ xs: 1, md: 2 }} />
          <RangeField
            name="numberOfVehicles"
            control={control}
            placeholder="Vehicles number"
            minRange={0}
            maxRange={100}
            label="vehicles"
          />
        </Box>
      </Box>
    </>
  );
};

export default FormSecondStep;
